import { EmployeeOptions } from 'src/services/api/options/employeeOptions';

export const employeeKeys = {
  all: ['employees'] as const,
  lists: () => [...employeeKeys.all, 'list'] as const,
  list: (options?: EmployeeOptions) => [...employeeKeys.lists(), { ...options }] as const,
  infinityList: (options?: EmployeeOptions) => [...employeeKeys.lists(), 'infinity', { ...options }] as const,
  byId: (guid: string) => [...employeeKeys.all, guid] as const,
};
